import { cn } from '@shared/lib';

export interface SegPillOption<T extends string> {
  key: T;
  label: string;
  count?: number;
}

interface SegPillsProps<T extends string> {
  options: SegPillOption<T>[];
  value: T;
  onChange: (next: T) => void;
  className?: string;
}

export function SegPills<T extends string>({ options, value, onChange, className }: SegPillsProps<T>) {
  return (
    <div
      className={cn(
        // На узких экранах сегменты не влезают в строку — даём горизонтальный
        // скролл вместо overflow/переноса (полоску прокрутки прячем).
        'inline-flex max-w-full overflow-x-auto rounded-pill bg-elev p-[3px] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden',
        className,
      )}
    >
      {options.map((o) => {
        const active = o.key === value;
        return (
          <button
            key={o.key}
            type="button"
            onClick={() => onChange(o.key)}
            className={cn(
              'shrink-0 whitespace-nowrap rounded-pill px-3.5 py-1.5 text-[14px] font-medium transition-colors outline-none',
              'focus-visible:ring-2 focus-visible:ring-accent/40',
              active ? 'bg-card text-fg' : 'text-muted hover:text-fg',
            )}
          >
            {o.label}
            {o.count !== undefined && <span className="ml-1 text-[12px] opacity-55">{o.count}</span>}
          </button>
        );
      })}
    </div>
  );
}
